export interface ErrorMessage {
  code: string;
  message: string;
}

export const ERROR_MESSAGES: ErrorMessage[] = [
  { code: 'ERR001', message: 'Desculpe, perdemos a conexão com nosso sistema. Vamos tentar outra vez? Caso o problema persista, aguarde 5 min e tente novamente' },
];
